; ( function ( doc, win ) {

	// 获取屏幕方向
	var getScreenOrientation = function () {
		var dir; // dir=0竖屏，dir=1横屏
		var orientation = screen.orientation || {};
		if ( orientation.type === "landscape-primary" ) {
			// 设备处于横屏模式
			dir = 1; // 横屏
		} else if ( orientation.type === "portrait-primary" ) {
			// 设备处于竖屏模式
			dir = 0; // 竖屏
		} else {
			// 无法检测设备方向
			dir = 1;
		}

		return dir;
	}

	// 获取屏幕尺寸
	var getScreenSize = function () {
		// var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		// var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		var width = window.screen.width;
		var height = window.screen.height;

		return { width: width, height: height };
	}

	var resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
	var recalc = function () {


		var designWidth = 1920; // 设计稿宽度
		var orientation = getScreenOrientation();
		var screenSize = getScreenSize();

		// console.log( "屏幕方向：" + ( orientation === 0 ? "竖屏" : "横屏" ) );
		// console.log( "屏幕尺寸：" + screenSize.width + "x" + screenSize.height );
		var body = document.getElementsByTagName( 'body' )[ 0 ];
		var bodyClass = body.className;
		var baseFontSize = 16;
		if ( bodyClass.indexOf( "mobile" ) !== -1 ) {

			// 移动端
			if ( orientation === 0 ) {
				// 竖屏
				designWidth = 375;
				baseFontSize = 16

			} else {
				// 横屏
				designWidth = 750;
				baseFontSize = 16
			}

		} else {
			// console.log( 'isMobile1:', orientation );
			//电脑端 
			if ( orientation === 0 ) {	// 竖屏
				designWidth = 1920;//横竖判断电脑上不准确,待完善
			} else {	// 横屏		
				designWidth = 1920;
			}
		}
		var docEl = doc.documentElement;//documentElement 属性是根节点
		var clientWidth = screenSize.width;
		if ( !clientWidth ) return;
		var lang = navigator.language;
		docEl.style.fontSize = baseFontSize * ( clientWidth / designWidth ) + 'px'; // 根据设计稿解算根元素的font-size
		// console.log( clientWidth, designWidth, baseFontSize, baseFontSize * ( clientWidth / designWidth ) + 'px' );
	}

	if ( !doc.addEventListener ) return;
	win.addEventListener( resizeEvent, recalc, false );
	doc.addEventListener( 'DOMContentLoaded', recalc, false );
} )( document, window );
